<div class="toc-layout-main sca-services-lising">
  <ul class="dfwp-list">
     <li class="level-section level-item-pos level-item level-bullet">
        <div class="level-header">
          <span class="headertitle headermarker"> 
            <a (click)="navigate('/Services/WaterServices/Pages/default.aspx')">
               <i class="icon-water-services"></i>
               {{'FRONT_USER.SERVICES.WATER_SERVICES' | translate }}
            </a>
          </span>
        </div>
     </li>
     <li class="level-section level-item-pos level-item level-bullet">
        <div class="level-header">
          <span class="headertitle headermarker"> 
            <a (click)="navigate('/Services/Pages/EShipyardServices.aspx')">
               <i class="icon-shipyards"></i>
               {{'FRONT_USER.SERVICES.SHIPYARD_SERVICES' | translate }}
            </a>
          </span>
        </div>
     </li> 
     <li class="level-section level-item-pos level-item level-bullet">
        <div class="level-header">
           <span class="headertitle headermarker"> 
              <a (click)="navigate('/Services/Pages/ETransitRequest.aspx')">
               <i class="icon-ebooking"></i>
               {{'FRONT_USER.SERVICES.E_BOOKING' | translate }}
            </a>
           </span>
        </div>
     </li> 
     <li class="level-section level-item-pos level-item level-bullet">
        <div class="level-header">
           <span class="headertitle headermarker"> 
              <a (click)="navigate('/Services/Pages/ELongHaul.aspx')">
               <i class="icon-long-haul"></i>
               {{'FRONT_USER.SERVICES.LONG_HAUL' | translate }}
            </a>
         </span>
      </div>
     </li> 
     <li class="level-section level-item-pos level-item level-bullet">
        <div class="level-header">
           <span class="headertitle headermarker"> 
              <a (click)="navigate('/Services/Pages/Tenders.aspx')">
               <i class="icon-tenders"></i>
               {{'FRONT_USER.SERVICES.TENDERS' | translate }}
            </a>
         </span>
      </div>
     </li> 
  </ul>
</div>
